import { forwardRef, Ref, SVGAttributes } from 'react';
type Props = SVGAttributes<SVGSVGElement>;
const CaretDownIcon = forwardRef((props: Props, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <path d="M16.25 7.5 10 13.75 3.75 7.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>);
export default CaretDownIcon;